const setAuth = (state, authStatus) => {
  state.isAuthenticated = authStatus
}

const setCanViewerShare = (state, payload) => {
  state.canViewerShare = payload
}

const setCanEditPresentation = (state, payload) => {
  state.canEditPresentation = payload
}

const setCurrentTokenValue = (state, currentTokenValue) => {
  state.currentTokenValue = currentTokenValue
}

const setAhaSequenceNumber = (state, payload) => {
  state.ahaSequenceNumber = payload
}

const setOffsetTime = (state, payload) => {
  state.offsetTime = payload
}

const setIsNewPresentation = (state, payload) => {
  state.isNewPresentation = payload
}

export default {
  setAuth,
  setCanViewerShare,
  setCanEditPresentation,
  setCurrentTokenValue,
  setAhaSequenceNumber,
  setOffsetTime,
  setIsNewPresentation,
}
